import {Button} from './Button'

import type {ButtonProps} from './Button'

export interface ResponsiveButtonProps {
  uniqueProps: Record<string, ButtonProps>
  commonProps?: ButtonProps
}

export const ResponsiveButton = ({uniqueProps, commonProps}: ResponsiveButtonProps) => {
  const mergedProps: ButtonProps[] = Object.entries(uniqueProps)
    .map(([key, buttonProps]) => ({
      key,
      ...commonProps,
      ...buttonProps,
    }))

  return (
    <>
      {mergedProps.map(({key, children, ...restProps}) => (
        <Button
          key={key}
          {...restProps}
        >
          {children}
        </Button>
      ))}
    </>
  )
}